module.exports = __webpack_public_path__ + "img/titlebg.d95d83a9.png";